let supportChatSendGeneration = 0;

export const beginSupportChatSend = (): number => {
    supportChatSendGeneration += 1;

    return supportChatSendGeneration;
};

export const getSupportChatSendGeneration = (): number => supportChatSendGeneration;

export const isLatestSupportChatSend = (sendGeneration: number): boolean =>
    sendGeneration === supportChatSendGeneration;
